import * as React from 'react';

import {Button} from 'shells/button/button';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {EstimatedInvoice} from './next-estimated-invoice';
import {PreviousInvoicesModal} from './previous-invoices-modal';

import styles from './previous-invoices.module.css';

type Props = {
    lastThreeInvoices: EstimatedInvoice[];
};

export function PreviousInvoices(props: Props) {
    const [isViewingAll, setIsViewingAll] = React.useState<boolean>(false);

    return (
        <>
            <div>
                <div className='flex justify-sb'>
                    <UppercaseLabel>Previous invoices</UppercaseLabel>
                    <Button
                        onClick={() => setIsViewingAll(true)}
                        variant='text-primary'
                        size='small'
                        noPadding={true}
                    >
                        View all
                    </Button>
                </div>
                <div className={styles.invoices}>
                    {props.lastThreeInvoices.map((invoice) => (
                        <div className='flex justify-sb pad-8' key={invoice.date}>
                            <Body size='small'>
                                <FormattedTimestamp
                                    format={FormattedTimestamp.formats.longMonthDayWithYear}
                                    datetime={invoice.date}
                                />
                            </Body>
                            <Body size='small'>{invoice.amount}</Body>
                        </div>
                    ))}
                </div>
            </div>
            {isViewingAll && <PreviousInvoicesModal onClose={() => setIsViewingAll(false)} />}
        </>
    );
}
